import type { components } from "./schema";

type S = components["schemas"];

export type Me = S["MeOut"];
export type UserWithPapers = S["UserWithPapers"];
export type NewspaperRef = S["NewspaperRef"];
export type Newspaper = S["NewspaperOut"];
export type Template = S["TemplateOut"];
export type TemplateBody = S["TemplateBody"];
export type Sponsor = S["SponsorOut"];
export type Asset = S["AssetOut"];
export type Reel = S["ReelOut"];
export type ReelSummary = S["ReelSummary"];
export type Deck = S["Deck-Output"];
export type DeckIn = S["Deck-Input"];
export type Card = S["Card-Output"];
export type DeckSettings = S["DeckSettings-Output"];
export type Job = S["JobOut"];
export type Issue = S["Issue"];
export type Lengths = S["Lengths"];
export type Meta = S["MetaOut"];
export type InviteOut = S["InviteOut"];
export type InviteInfo = S["InviteInfo"];
export type Build = S["BuildOut"];
export type ReelDefaults = S["ReelDefaults-Output"];
export type Session = S["SessionOut"];
export type MemberOut = S["MemberOut"];

export type ReelStatus = Reel["status"];
export type CardType = Card["type"];
export type Language = "en" | "hi" | "mr";

export const LANGUAGE_NAMES: Record<Language, string> = { en: "English", hi: "Hindi", mr: "Marathi" };
export type TemplateTexts = S["TemplateTexts-Input"];
